
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-restoration",
      function () {
        return require("private-next-pages/photo-restoration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-restoration"])
      });
    }
  